import PageHeader from '@Guidelines/Layout/PageHeader';
import SsoContent from '@UI/Pages/Administration/Sso/SsoContent';
import SsoNotifications from '@UI/Pages/Administration/Sso/SsoNotifications';
import type * as React from 'react';
import PageContainer from '@Guidelines/Layout/PageContainer';

const SsoPage: React.FC = () => {
	return (
		<PageContainer>
			<PageHeader
				eyebrow="CONFIGURATION"
				title="Fournisseur d’identité"
				description="Ce réglage détermine ce que propose l’écran de connexion."
			/>
			<SsoContent />
			<SsoNotifications />
		</PageContainer>
	);
};

export default SsoPage;
